// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useMemo, useState } from "react";
import { Stack, Switch, useMediaQuery, useTheme } from "@mui/material";
import {
  GridColDef,
  GridActionsCellItem,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import { Loading, StatusBar } from "../../atoms";
import {

  IMerchantVPos,

  useAuthorization,
  useGetMerchantVPosList,
  useMerchantVPosDelete,
  useMerchantVPosUpdate,
} from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { PagingResponse } from "../../../hooks/_types";
import { downloadExcel } from "../../../util/downloadExcel";

import { useUserInfo } from "../../../store/User.state";
import dayjs from "dayjs";


function RenderStatus(props: GridRenderCellParams<any, string>) {
    const { value } = props;
  
    return <>{value && <StatusBar status={value} />}</>;
  }
  
  type BusinessBankListingProps = {
    onRowClick?: (data: { id: GridRowId; row: any }) => void;
  };
  
  export const BusinessBankListingActiveTable = ({
    onRowClick,
  }: BusinessBankListingProps) => {
    const [userInfo] = useUserInfo();
    const theme = useTheme();
    const {showDelete, showUpdate} = useAuthorization();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [queryOptions, setQueryOptions] = React.useState({});
    const [shouldRefresh, setShouldRefresh] = React.useState(false);
    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const [paginationModel, setPaginationModel] = React.useState({
      page: 0,
      pageSize: 25,
    });
    const {
      mutate: getMerchantVPosList,
      isLoading,
    } = useGetMerchantVPosList();
    const { mutate: merchantVPosUpdate } = useMerchantVPosUpdate();
    const navigate = useNavigate();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(0);
    const { mutate: merchantVPosDelete, isLoading: isDeleteLoading } =
      useMerchantVPosDelete();
    const setSnackbar = useSetSnackBar();


    const editRow = React.useCallback(
        (merchantVPos: IMerchantVPos) => () => {
          navigate("/vpos-management/merchant-vpos-bankdefinition", { state: merchantVPos });
       
          
        },
        [navigate]
      );

  const deleteRow = React.useCallback(
    (merchantVPos: IMerchantVPos) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(merchantVPos.id));
    },
    []
  );
  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  useEffect(() => {
    const savedFilter = localStorage.getItem("businessBankListActiveTabFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);


  useEffect(() => {
    const requestPayload = {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: "ACTIVE",
        merchantId: userInfo ? Number(userInfo.merchantId) : undefined,
        ...getQueryParams(queryOptions),
      };
    
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getMerchantVPosList(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data?.data);
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
    setShouldRefresh(false);
  }, [
    getMerchantVPosList,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh
  ]);

  // , queryOptions

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    getMerchantVPosList(
      {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: "ACTIVE",
        merchantId: userInfo ? Number(userInfo.merchantId) : undefined
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };


  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteMerchantVPosRequest = { id: selectedRowId };

    merchantVPosDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
            getMerchantVPosList({
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            status: "ACTIVE",
          });
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const handleinternationalBank = (event: React.ChangeEvent<HTMLInputElement>, rowId) => {
    const val = event.target.checked;
    merchantVPosUpdate(
      {
        id: rowId,
        merchantId: params.row.merchantId,
        bankCode: params.row.bankCode,
        internationalBank: val,
        status: "ACTIVE",
      },
      {
        onSuccess: () => {
          // Tüm satırların 'internationalBank' değerlerini güncelle
          const updatedRows = data.map(row => ({
            ...row,
            internationalBank: row.id === rowId ? val : false
          }));
  
          // State'i güncellenmiş verilerle ayarla
          setData(updatedRows);
          setShouldRefresh(true);
        },
      }
    );
  };
  
  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          return [
            !!showUpdate ? <GridActionsCellItem
              label="Düzenle"
              onClick={editRow(params.row)}
              showInMenu
            /> : <></>,
            !!showDelete ? <GridActionsCellItem
              label="Sil"
              onClick={deleteRow(params.row)}
              showInMenu
            /> : <></>,
          ];
        },
      },
      { field: "bankName", headerName: "Banka Adı", width: 400 },
  
      { field: "merchantName", headerName: "Üye İşyeri Adı", width: 200 },
      { field: "merchantId", headerName: "Üye İşyeri Numarası", width: 200, },
      {
        field: "createDate",
        headerName: "Oluşturma Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "createUserName", headerName: "Oluşturan Kullanıcı", width: 200 },
      {
        field: "updateDate",
        headerName: "Son Güncellenme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "updateUserName", headerName: "Son Güncelleyen Kullanıcı", width: 200 },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "Durum",
        width: 150,
        filterable: false
      },
      {
        headerName: "Varsayılan",
        field: "actions",
        type: "actions",
        width: 120,
        getActions: (params) => {
          const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const val = event.target.checked;
            merchantVPosUpdate(
              {
                id: params.row.id,
                merchantId: params.row.merchantId,
                bankCode: params.row.bankCode,
                defaultBank: val,
                internationalBank: params.row.internationalBank,
                status: "ACTIVE",
              },
              {
                onSuccess: () => {
                  setShouldRefresh(true);
                },
              }
            );
          };
          return [<Switch checked={params.row.defaultBank} onChange={handleChange} />];
        },
        
      },
      {
        headerName: "Yurtdışı Banka",
        field: "internationalBank",
        type: "actions",
        width: 200,
        getActions: (params) => {
          const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const val = event.target.checked;
            merchantVPosUpdate(
              {
                id: params.row.id,
                merchantId: params.row.merchantId,
                bankCode: params.row.bankCode,
                internationalBank: val, 
                defaultBank: params.row.defaultBank,
                status: "ACTIVE",
              },
              {
                onSuccess: () => {
                  setShouldRefresh(true);
                },
              }
            );
          };
          return [<Switch checked={params.row.internationalBank} onChange={handleChange} />];
        },
      }
    ];
  }, [deleteRow, editRow, getMerchantVPosList, merchantVPosUpdate, paginationModel.page, paginationModel.pageSize, showDelete, showUpdate]);

  const onSave = () => {

    const requestPayload = {
        size: -1,
        page: 0,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: "ACTIVE",
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    getMerchantVPosList(
 requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Banka Adı": item?.bankName,
                  "Üye İşyeri Adı": item?.merchantName,
                  "Üye İşyeri Numarası": item?.merchantId,
                  "Durum": item?.status,
                  "Oluşturma Tarihi": item?.createDate,
                  "Oluşturan Kullanıcı": item?.createUserName,
                  "Son Güncellenme Tarihi":item?.updateDate,
                  "Güncelleyen Kullanıcı":item?.updateUserName,
                  "Varsayılan Banka": item?.defaultBank
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(refactoredData || [], "Aktif Banka Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };


  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem('businessBankListActiveTabFilter')
      return setQueryOptions({});
    }
  
    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);
    
    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;
  
    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }
  
    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem('businessBankListActiveTabFilter', JSON.stringify(queryParams))
    }
  
    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;
  
  }, 500);
  
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

  const hasLoading = isLoading || isDeleteLoading;

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>
     
          <>
            <Table
             columnVisibilityConfigKey="businessBankListActiveTabColumnVisibilityKey"
                filterKey="businessBankListActiveTabFilter"
                hasActiveFilters={hasActiveFilters}
              handleFilterChange={handleFilterChange}
              paginationModel={paginationModel}
              onPaginationModelChange={handleChangePagination}
              paginationMode="server"
              rowCount={tableData?.totalItems || 0}
              onRowClick={onRowClick}
              sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
              isRowSelectable={() => false}
              // disableColumnMenu
              rows={
                tableData?.result 
                  ? tableData.result.filter(item => item.status === "ACTIVE") 
                  : []
              }
              columns={columns}
              exportFileName="Aktif Banka Listesi"
              onSave={() => onSave()}
            />
            <DeleteConfirmModal
              isOpen={isDeleteModalOpen}
              onClose={handleCloseDeleteModal}
              onConfirm={() => handleDeleteConfirm()}
            ></DeleteConfirmModal>
          </>
      
      </Stack>
    </>
  );
};
